<template>
  <div class="mb-5">
    <span class="px-2 d-block pb-3 d-block text-capitalize sub-title"
      ><slot name="subtitle"></slot>
    </span>

    <div class="position-relative d-flex dropdown-Body align-items-center">
      <img
        class="position-absolute search-icon"
        src="@/assets/images/create-survey/search.svg"
        width="25"
        height="25"
        alt="search"
      />
      <slot name="dropdownBody"></slot>
    </div>
    <transition name="fade">
      <small class="text-danger text-capitalize px-4">
        <slot name="warning"></slot>
      </small>
    </transition>
  </div>
</template>

<script>
export default {
  name: "DropdownWithSearchUI",
};
</script>

<style lang="scss" scoped>
.sub-title {
  @extend %font-26_28-regular;
}

.search-icon {
  z-index: 1;
  left: 18px;
  width: 1.5625rem;
}
</style>
